export { apiMindbox } from 'next-flight-server-reference-proxy-loader?id=7f62f47fe612bfee9e5957152416c0d20dbcfed06c&name=apiMindbox!'